import React, { ReactElement, useMemo } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

/*
*   Горизонтальные табы
*/

type ITabsArrayItem = {
    tabLabel: string | ReactElement,
    tabComponent: React.ReactNode,
    isHide?: boolean,
}

type ITabsCustom = {
    tabsArray: ITabsArrayItem[],
    setCurrentTabIndex?: ((index: number) => void) | undefined,
    saveCurrentActiveTabAs?: string | undefined,
    isCacheTabs?: boolean,
}

type TabPanelProps = {
    children?: React.ReactNode,
    tabIndex: number,
    isActive: boolean,
    isCacheTabs: boolean,
}


function TabPanel(props: TabPanelProps) {
    const { children, isActive, tabIndex, isCacheTabs, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={!isActive}
            id={`simple-tabpanel-${tabIndex}`}
            aria-labelledby={`simple-tab-${tabIndex}`}
            {...other}
        >
            {!isCacheTabs && isActive && (
                <Box sx={{ pt: 3, pb: 0 }}>
                    {children}
                </Box>
            )}
            {isCacheTabs && <Box sx={{ pt: 3, pb: 0 }}>{children}</Box>}
        </div>
    );
}


function a11yProps(tabIndex: number) {
    return {
        id: `simple-tab-${tabIndex}`,
        'aria-controls': `simple-tabpanel-${tabIndex}`,
    };
}


export function TabsCustom({
    tabsArray,
    setCurrentTabIndex = undefined,
    saveCurrentActiveTabAs = undefined,
    isCacheTabs = false,
}: ITabsCustom) {
    const [value, setValue] = React.useState(saveCurrentActiveTabAs ? (Number(localStorage.getItem(saveCurrentActiveTabAs)) || 0) : 0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        if (setCurrentTabIndex)
            setCurrentTabIndex(newValue);
        if (saveCurrentActiveTabAs)
            localStorage.setItem(saveCurrentActiveTabAs, newValue.toString());
    }

    const tabList = useMemo(() => tabsArray.map((item, tabIndex) => ({ tabIndex, ...item })), [tabsArray]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value || 0}
                    onChange={handleChange}
                    aria-label="basic tabs">
                    {
                        tabList.filter(t => !t.isHide).map((tab) => (
                            <Tab key={tab.tabIndex}
                                label={tab.tabLabel}
                                {...a11yProps(tab.tabIndex)} />
                        ))
                    }
                </Tabs>
            </Box>
            {
                tabList.filter(t => !t.isHide).map((tab) => (
                    <TabPanel key={tab.tabIndex}
                        isActive={tab.tabIndex === value}
                        tabIndex={tab.tabIndex}
                        isCacheTabs={isCacheTabs}>
                        {tab.tabComponent}
                    </TabPanel>
                ))
            }
        </Box>
    );
}